import API from './axios';

// --- PRODUCT APIs ---
export const fetchAllProducts = () => API.get('/products');
export const fetchAvailableProducts = () => API.get('/products/available');
export const fetchProductById = (id) => API.get(`/products/${id}`);
export const searchProducts = (keyword) =>
  API.get('/products/search', { params: { keyword } });

// 🚀 FormData və ya JSON olmasına uyğun təhlükəsiz sorğu
export const createProduct = (productData) => {
  if (productData instanceof FormData) {
    return API.post('/products', productData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  return API.post('/products', productData);
};

export const updateProduct = (id, productData) => {
  if (productData instanceof FormData) {
    return API.put(`/products/${id}`, productData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  return API.put(`/products/${id}`, productData);
};

export const deleteProduct = (id) => API.delete(`/products/${id}`);

// --- ORDER APIs ---
export const createOrder = (orderData) => API.post('/orders', orderData);
export const fetchAllOrders = () => API.get('/orders');
export const fetchOrderById = (id) => API.get(`/orders/${id}`);
export const fetchOrderByNumber = (orderNumber) =>
  API.get(`/orders/number/${orderNumber}`);

export const updateOrderStatus = (id, status) =>
  API.put(`/orders/${id}/status?status=${status}`, { status });

const storeApi = {
  fetchAllProducts,
  fetchAvailableProducts,
  fetchProductById,
  searchProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  createOrder,
  fetchAllOrders,
  fetchOrderById,
  fetchOrderByNumber,
  updateOrderStatus,
};

export default storeApi;